export default "__VITE_ASSET__9d57a6d8__"